import createBarkerSvg from '@sparta.credit-cards.utilities/barker-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import performanceMetaUtility from '@sparta.global.utilities/performance-meta-utility/dist/es6.js';
import sbCreditCardUtility from '@sparta.sb-credit-cards.utilities/sb-credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import sbCreditCardsHelper, { termsAndConditions, applyNow, getProgramRulesLink } from '@sparta.sb-credit-cards.helpers/sb-credit-cards/dist/es6.js';
import { is } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"campaign-content\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":4,"column":42},"end":{"line":4,"column":60}}}))
    + "\"></div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"productProperties\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"campaignProperties") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":34,"column":40},"end":{"line":34,"column":75}}}))
    + "\"></div>\r\n";
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"is")||(depth0 && lookupProperty(depth0,"is"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cardId") : depth0),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"cardId") : stack1),{"name":"is","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":1},"end":{"line":75,"column":8}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "		<div class=\"row\">\r\n			<div class=\"large-12 column\">\r\n				<div class=\"content-left-column large-3 medium-3 small-6 small-offset-3\">\r\n					<div class=\"row\">\r\n						<div class=\"card-art-image-wrapper\">\r\n							<div class=\"barker-placeholder\"></div>\r\n							<img class=\"sbcc-card-art\" src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"cardImage") : stack1), depth0))
    + "\" alt=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"alt") : stack1), depth0)) != null ? stack1 : "")
    + "\" />\r\n						</div>\r\n					</div>\r\n					<div class=\"row show-for-medium-up sbcc-ratings-placeholder\">\r\n					</div>\r\n          <div class=\"offer-terms\" id=\"offerTermsUnderCard\"></div>\r\n				</div>\r\n				<div class=\"content-right-column large-9 medium-9 small-12\">\r\n					<h2>"
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n					<p class=\"subtext\">\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </p>\r\n					<div>\r\n            <div id=\"tncContainer\">\r\n              <p class=\"no-space\" id=\"applyNowContainer\"></p>\r\n              <p class=\"no-space terms-container\">\r\n                <a class=\"terms spa-boa-tnc-window\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"camelCaseId") : stack1), depth0))
    + "TermsConditions\"\r\n                  href=\"/smallbusiness/credit-cards/terms-and-conditions/?campaignid="
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"campaignId") || (depth0 != null ? lookupProperty(depth0,"campaignId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"campaignId","hash":{},"data":data,"loc":{"start":{"line":61,"column":85},"end":{"line":61,"column":101}}}) : helper)))
    + "&productoffercode="
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"pocode") || (depth0 != null ? lookupProperty(depth0,"pocode") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pocode","hash":{},"data":data,"loc":{"start":{"line":61,"column":119},"end":{"line":61,"column":131}}}) : helper)))
    + "&locale=en_US\">\r\n                  "
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"termsConditionsText") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                </a>\r\n              </p>\r\n              <p id=\"programRulesContainer\"></p>\r\n            </div>\r\n					</div>\r\n				</div>\r\n			</div>\r\n		</div>\r\n		<div class=\"show-for-small-only row\">\r\n			<div class=\"large-12 column sbcc-ratings-placeholder\">\r\n			</div>\r\n		</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"prod-overview-catalogs\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"catalogs") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":1,"column":43},"end":{"line":1,"column":60}}}))
    + "\"></div>\r\n<div class=\"data1\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":2,"column":29},"end":{"line":2,"column":45}}}))
    + "\"></div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "")
    + "\r\n<div id=\"sbccRatings\">\r\n	<div class=\"helper-placeholder sbcc-ratings\" data-helper=\"rating\"\r\n	     data-helper-params='{\"toggle\":\"{{{ cadets.PRODUCT_REVIEW_RATING_ENABLE }}}\", \"value\": \"{{{ cadets.PRODUCT_REVIEW_RATING }}}\", \"URL\":\"{{{ cadets.PRODUCT_REVIEW_RATING_VALUE }}}\", \"CLASS\":\"rating-link\", \"ID\":\"ratings-@key\", \"TARGET\": \"_blank\"}'>\r\n		"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"cadets") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n	</div>\r\n</div>\r\n<div id=\"sbccSVG\">\r\n	"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"barkerPlaceholder") || (depth0 != null ? lookupProperty(depth0,"barkerPlaceholder") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"barkerPlaceholder","hash":{},"data":data,"loc":{"start":{"line":14,"column":1},"end":{"line":14,"column":24}}}) : helper))) != null ? stack1 : "")
    + "\r\n</div>\r\n<div id=\"applyNowTemplate\">\r\n  {{{applyNow applyNowLink requestType campaignId site sparta false catalog}}}\r\n</div>\r\n<div id=\"offerTermsTemplate\">\r\n  {{{termsAndConditions\r\n    termsAndConditionsLink\r\n    campaignId\r\n    site\r\n    sparta\r\n    true\r\n    offerLinks.OFFER_TERMS_LABEL\r\n  }}}\r\n</div>\r\n<div id=\"programRulesTemplate\">\r\n  {{{getProgramRulesLink programRulesPopup offerLinks.PROGRAM_RULES_LABEL\r\n    offerLinks.PROGRAM_RULES_LINK}}}\r\n</div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":0},"end":{"line":35,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"catalogs") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":0},"end":{"line":76,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/product-engagement-echo-sbcc-module",
  "version": "3.0.0",
  "id": "productEngagementEchoSbccModule",
  "containerID": "sbCreditCardsProductEngagementEchoSbccModule",
  "moduleName": "sb-credit-cards-product-engagement-echo-sbcc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "product-engagement-echo-sbcc-module",
  "data": {
    "init": "ProductEngagementEchoSbccModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "requestParams",
    "type": "object",
    "default": {},
    "description": "Query string parameters to the service."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        is,
        json,
        termsAndConditions,
        applyNow,
        getProgramRulesLink
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    is,
    json,
    termsAndConditions,
    applyNow,
    getProgramRulesLink
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/barker-utility": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.sb-credit-cards.helpers/sb-credit-cards": "^2.0.0",
    "@sparta.global.utilities/performance-meta-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.sb-credit-cards.utilities/sb-credit-card-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @export
 * @class ProductEngagementEchoSbccModule
 * @extends {ModuleUtility}
 */
class ProductEngagementEchoSbccModule extends Module {
  /**
   * Creates an instance of ProductEngagementEchoSbccModule.
   * @param {Object} options // Module options
   * @param {Object} context // Module context
   * @memberof ProductEngagementEchoSbccModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    try {
      this.data1 = Object.values(JSON.parse(target.querySelector('.data1').dataset.jcr));
      const campaignContent = target.querySelector('.campaign-content');
      this.campaignContent = campaignContent ? JSON.parse(campaignContent.dataset.jcr) : null;
      this.catalogs = JSON.parse(target.querySelector('#prod-overview-catalogs').dataset.jcr);
      this.cardCampaign = '';
      Object.values(this.catalogs).forEach(card => {
        if (card.cardId === this.data1[0]) {
          this.cardCampaign = `${card.campaignId}~${card.pocode}`;
          this.card = card;
        }
      });
    } catch (exception) {
      console.error(exception);
    }
  }

  /**
   * @memberof ProductEngagementEchoSbccModule
   * @returns {void}
   */
  init() {
    const contentProductProperties = document.querySelector('#productProperties');
    const barkerProperties = ['BARKER_COLOR', 'BARKER_POSITION', 'BARKER_TEXT'];
    if (contentProductProperties) {
      this.productProperties = JSON.parse(contentProductProperties.dataset.jcr);
    } else {
      this.productProperties = [];
    }
    sbCreditCardUtility.productPropertiesMap(this.params.requestParams, [this.cardCampaign], [...this.productProperties, ...barkerProperties]).then(result => {
      this.cardCampaignLocale = Object.keys(result)[0];
      const cardInfo = result[Object.keys(result)[0]];
      if (result[Object.keys(result)[0]].BARKER_POSITION) {
        const {
          BARKER_POSITION,
          BARKER_TEXT,
          BARKER_COLOR
        } = cardInfo;
        const barkerPlaceholder = createBarkerSvg(BARKER_TEXT, BARKER_POSITION, cardInfo, BARKER_COLOR);
        this.updatePartial('#sbccSVG', '.barker-placeholder', {
          barkerPlaceholder
        });
      }
      const offerLinks = this.productProperties.reduce((accum, prev) => ({
        ...accum,
        [prev]: cardInfo[prev]
      }), {});

      // TODO: Remove after May 2019 release if feature flag is not enabled.
      // In potential edge cases, the welcome.go page needs to be prefetched to reset cookies.
      // This is a feature flag in case this edge case comes up during release.
      if (spaParams.siteParams.shouldPrefetchApplicationWelcomePage) {
        const metaTags = {
          link: [{
            rel: 'prefetch',
            href: `${spaParams.siteParams.secureHost}/applynow/welcome.go`
          }]
        };
        performanceMetaUtility.addMetaFromObject(metaTags);
      }
      performanceMetaUtility.addMetaFromClasses();
      Handlebars.registerHelper('applyNow', applyNow);
      this.renderApplyNow(this.cardCampaignLocale);

      // Only render if we've gotten back offer links & program rules data AND they're enabled
      if (offerLinks && offerLinks.OFFER_TERMS_ENABLE && offerLinks.OFFER_TERMS_ENABLE === 'YES') {
        this.renderOfferTerms(this.cardCampaignLocale, offerLinks);
      }
      if (offerLinks && offerLinks.PROGRAM_RULES_ENABLE && offerLinks.PROGRAM_RULES_ENABLE === 'YES') {
        this.renderProgramRules(offerLinks);
      }
      // ------------------------------

      const subtext = this.settings.target.querySelector('p.subtext');
      const offerTermsLinks = subtext.querySelectorAll("a[href='#creditCardTnCAnchor']");
      if (offerTermsLinks) {
        offerTermsLinks.forEach(offerTermLink => {
          const offerTermLinkObject = {
            ID: offerTermLink.id,
            content: '',
            CLASS: 'spa-boa-tnc-window',
            URL: offerTermLink.href
          };
          const anchorString = sbCreditCardsHelper.helpers.termsAndConditions(offerTermLinkObject, this.card.campaignId, spaParams.siteParams, sparta, true, offerLinks.OFFER_TERMS_LABEL);

          // Parse string for URL and programmatically obtain the href.
          const tempDivEl = document.createElement('div');
          tempDivEl.innerHTML = anchorString;
          const parsedAnchorTag = new URL(tempDivEl.firstChild);

          // Update offer terms link with correct href and popup class
          // eslint-disable-next-line no-param-reassign
          offerTermLink.href = parsedAnchorTag.href;
          offerTermLink.classList.add(offerTermLinkObject.CLASS);
        });
      }
    });

    // Hacky solution for settings footer link
    if (document.getElementById('ModuleFooter_SIPC')) {
      const newTermsLink = document.querySelector('.terms-and-conditions-card').getAttribute('data-href');
      document.getElementById('ModuleFooter_SIPC').setAttribute('href', newTermsLink);
    }
    this.bindEventListeners();
  }

  /**
   *
   * @returns {void}
   */
  bindEventListeners() {
    sbCreditCardUtility.delegateEvent('click', '.spa-boa-tnc-window', this.handleTermsLink.bind(this), false, this.settings.target);
    sbCreditCardUtility.delegateEvent('click', '.spa-boa-program-rules-window', this.handleRulesLink.bind(this), false, this.settings.target);
  }

  /**
   * handleTermsLink
   *
   * @param {Event} e // Module event
   * @returns {void}
   */
  handleTermsLink(e) {
    e.preventDefault();
    sbCreditCardUtility.openPopupLink(e, 'TermsConditions');
  }

  /**
   * handleRulesLink
   *
   * @param {Event} e - click event
   * @returns {void}
   */
  handleRulesLink(e) {
    e.preventDefault();
    sbCreditCardUtility.openPopupLink(e, 'programRulesWin');
  }

  /**
   * @param {any} partial Partial to be rendered during run-time
   * @param {any} wrapper Div to target for rendered partial
   * @param {any} state Object to be passed to the partial
   * @memberof ProductEngagementEchoSbccModule
   * @returns {void}
   */
  updatePartial(partial, wrapper, state) {
    const myPartial = this.settings.target.querySelector(partial);
    const myWrapper = this.settings.target.querySelector(wrapper);
    const source = myPartial.innerHTML;
    const template = Handlebars.compile(source);
    const html = template(state);
    myWrapper.innerHTML = html;
  }

  /**
   * renderApplyNow
   *
   * @param {String} campaignId // apply now campaign ID
   * @returns {void}
   */
  renderApplyNow(campaignId) {
    const templateEl = document.querySelector('#applyNowTemplate');
    if (!templateEl) {
      return;
    }
    const template = templateEl.innerHTML;
    const cardContent = this.catalogs[spaParams.pageParams.cardId].content;
    const applyNowLink = {
      ID: cardContent.camelCaseId,
      content: `${cardContent.applyBtn} <span class="ada-hidden">${cardContent.applyBtnADA}</span>`,
      CLASS: 'apply update-tracking-codes spa-prefetch',
      button: {
        skin: 'primary',
        size: 'medium',
        block: false
      }
    };
    const data = {
      campaignId,
      sparta,
      site: spaParams.siteParams,
      params: this.params,
      applyNowLink,
      catalog: this.catalogs,
      requestType: 'BCC'
    };
    Handlebars.registerHelper('applyNow', applyNow);

    // Due to the tokens in the JCRs need to double compile.
    const firstRender = Handlebars.compile(template)(data);
    const container = document.querySelector('#applyNowContainer');
    container.innerHTML = Handlebars.compile(firstRender)(data);
    const marketingTrackCodeForApplyNow = `&mktg_track=${this.catalogs[spaParams.pageParams.cardId].marketingTrack[spaParams.pageParams.pageID][spaParams.pageParams.category]}&track=${this.catalogs[spaParams.pageParams.cardId].marketingCode}`;
    const trackingLinks = this.settings.target.querySelectorAll('.update-tracking-codes');
    Array.from(trackingLinks).forEach(link => {
      link.setAttribute('href', `${link.getAttribute('href')}${marketingTrackCodeForApplyNow}`);
    });
  }

  /**
   * renderOfferTerms
   *
   * @param {String} campaignId // Module offer terms campaign ID
   * @param {Object} offerLinks // Module offer links
   * @returns {void}
   */
  renderOfferTerms(campaignId, offerLinks = {}) {
    const templateEl = document.querySelector('#offerTermsTemplate');
    if (!templateEl) {
      return;
    }
    const template = templateEl.innerHTML;
    const data = {
      campaignId,
      sparta,
      site: spaParams.siteParams,
      termsAndConditionsLink: this.campaignContent.LINKS.termsAndConditionOffer,
      offerLinks
    };

    // Due to the tokens in the JCRs need to double compile.
    const firstRender = Handlebars.compile(template)(data);
    const container = document.querySelector('#offerTermsUnderCard');
    container.innerHTML = Handlebars.compile(firstRender)(data);
  }

  /**
   * renderProgramRules
   *
   * @param {Object} offerLinks // Module offer links
   * @returns {void}
   */
  renderProgramRules(offerLinks = {}) {
    const templateEl = document.querySelector('#programRulesTemplate');
    if (!templateEl) {
      return;
    }
    const template = templateEl.innerHTML;
    const data = {
      programRulesPopup: this.campaignContent.LINKS.programRulesPopup,
      offerLinks
    };

    // Due to the tokens in the JCRs need to double compile.
    const firstRender = Handlebars.compile(template)(data);
    const container = document.querySelector('#programRulesContainer');
    container.innerHTML = Handlebars.compile(firstRender)(data);
  }
}
registerModuleClass({
  moduleClass: ProductEngagementEchoSbccModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ProductEngagementEchoSbccModule as default, moduleConfig };
